import {
	createFileRoute,
	getRouteApi,
	useRouter,
} from '@tanstack/react-router';
import { TabLoadError } from '@/features/creators/dashboard/components/load-error';
import {
	LOAD_ERROR_TEXT,
	PAYOUT_TEXT,
} from '@/features/creators/dashboard/content';
import { PayoutPage } from '@/features/creators/dashboard/payout/payout-page';
import { fetchCommissions } from '@/features/creators/dashboard/services/fetch-commissions';
import { PageLoader } from '@/features/creators/shared/page-loader';

const dashboardRoute = getRouteApi('/_auth/ixi-finance/creators_/dashboard');

// /ixi-finance/creators/dashboard/payout — the Payout tab: balance, withdrawal and the
// first page of booking history. The balance comes from the dashboard layout's
// loader; History loads here.
export const Route = createFileRoute(
	'/_auth/ixi-finance/creators_/dashboard/payout',
)({
	loader: () => fetchCommissions(),
	component: PayoutRoute,
	pendingComponent: PageLoader,
	errorComponent: () => (
		<TabLoadError page={PAYOUT_TEXT.title} what={LOAD_ERROR_TEXT.payouts} />
	),
	// 'stay' means the URL hash changed without a route transition (the
	// Withdraw sheet opening or closing). Skip the reload so History keeps the
	// pages already loaded; router.invalidate() still reloads it.
	shouldReload: ({ cause }) => cause !== 'stay',
});

function PayoutRoute() {
	const { profile, payout } = dashboardRoute.useLoaderData();
	const history = Route.useLoaderData();
	const router = useRouter();
	return (
		<PayoutPage
			payout={payout}
			liveSince={profile.liveSince}
			history={history}
			reloadBalance={() => router.invalidate()}
		/>
	);
}
